import React from 'react';
import styles from './styles.module.scss';

interface VerticalBarProps {
  cpc: number;
  maxCpc: number;
}

export const VerticalBar: React.FC<VerticalBarProps> = ({cpc, maxCpc}) => {
  const percent = ((cpc * 100) / maxCpc).toFixed(0);
  return (
    <div className={styles.wrapper}>
      <div style={cpc == 0 ? {backgroundColor: '#34AEF3', height: '0px'} : parseInt(percent) > 5 ? {backgroundColor: '#34AEF3', height: `${parseInt(percent)}%`} : {backgroundColor: '#34AEF3', height: '3px'}}></div>
    </div>
  );
};
